import createIcon from '../../createIcon';

/**
 * @component @name KeyboardDoubleArrowRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi40MSA2TDUgNy40MUw5LjU4IDEyTDUgMTYuNTlMNi40MSAxOEwxMi40MSAxMkw2LjQxIDZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMgNkwxMS41OSA3LjQxTDE2LjE3IDEyTDExLjU5IDE2LjU5TDEzIDE4TDE5IDEyTDEzIDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardDoubleArrowRight = createIcon('KeyboardDoubleArrowRight', [
  ['path', { d: 'M6.41 6L5 7.41L9.58 12L5 16.59L6.41 18L12.41 12L6.41 6Z', key: '26melo' }],
  ['path', { d: 'M13 6L11.59 7.41L16.17 12L11.59 16.59L13 18L19 12L13 6Z', key: '1pqb7t' }],
]);

export default KeyboardDoubleArrowRight;
